module.exports = __webpack_public_path__ + "static/media/34-14.f2ce55b8.mp3";